'use strict';

require('jquery-zoom');

$.fn.doubletap = function (onDoubleTapCallback, onTapCallback) {
    var tapped = false;
    $(this).on('click', function (event) {
        if (!tapped) {
            // tapped within 400ms of last tap. double tap
            tapped = setTimeout(function (e) {
                tapped = null;
                if (onTapCallback != null && typeof onTapCallback === 'function') {
                    onTapCallback(e);
                }
            }, 400, event);
        } else {
            // stop single tap callback
            clearTimeout(tapped);
            tapped = null;
            if (onDoubleTapCallback != null && typeof onDoubleTapCallback === 'function') {
                onDoubleTapCallback(event);
            }
        }
        event.preventDefault();
        return false;
    });
};

var viewportWidth = {
    mobile: { maxWidth: 767, minWidth: 320 },
    tablet: { maxWidth: 1279, minWidth: 768 }
};

var layout = {
    viewports: viewportWidth,
    getMode: function () {
        var windowWidth = $(window).width() === window.outerWidth ? $(window).width() : window.outerWidth;
        if (windowWidth <= viewportWidth.mobile.maxWidth) {
            return 'mobile';
        } else if (windowWidth <= viewportWidth.tablet.maxWidth) {
            return 'tablet';
        }
        return 'desktop';
    },
    isMobile: function () {
        return this.getMode() === 'mobile';
    },
    isTablet: function () {
        return this.getMode() === 'tablet';
    },
    isDesktop: function () {
        return this.getMode() === 'desktop';
    }
};


/**
* @description Enables the zoom viewer on the product detail page
*/
function loadZoom() {
    if (layout.isDesktop()) {
        loadDesktopZoom();
    }
}

/**
 * loadMobileZoom
 */
function loadMobileZoom(event) {
    var $imgZoom = $('.product-wrapper').find('.carousel-item.slick-active .js-main-image');
    var hiresUrl = $imgZoom.find('img').attr('data-largeimage');

    if (!hiresUrl) {
        return;
    }

    $imgZoom.zoom({
        url: hiresUrl,
        on: 'click',
        onZoomOut: function () {
            $('.product-carousel').slick('slickSetOption', 'swipe', true, false);
        },
        onZoomIn: function () {
            $('.product-carousel').slick('slickSetOption', 'swipe', false, false);
        },
        callback: function () {
            var $zoomedImg = $(this);
            $zoomedImg.addClass('b-product_image-zoom_image');
            $zoomedImg.doubletap(function () {
                $('.b-product_image-zoom_image').remove();
                $('.product-carousel').slick('slickSetOption', 'swipe', true, false);
                $imgZoom.off('touchmove.zoom');
            });

            // simulate click event to immediate apply zoom after initialization
            var e = new $.Event('click', {
                originalEvent: event.originalEvent
            });

            $imgZoom.off('touchend.zoom');
            $imgZoom.off('touchstart.zoom');
            $imgZoom.trigger(e);

            $zoomedImg.one('touchend.zoom', function () {
                $imgZoom.off('zoom.destroy');
            });
            e.preventDefault();
        }
    });
}

/**
 * loadDesktopZoom
 */
function loadDesktopZoom() {
    var $imgZoom = $('.carousel-item.slick-active .js-main-image');
    var hiresUrl = $imgZoom.find('img').attr('data-largeimage');

    if (!hiresUrl) {
        return;
    }

    $imgZoom.zoom({
        url: hiresUrl,
        on: 'mouseover',
        onZoomOut: function () {
            $('.product-carousel').slick('slickSetOption', 'swipe', true, false);
        },
        onZoomIn: function () {
            $('.product-carousel').slick('slickSetOption', 'swipe', false, false);
        },
        callback: function () {
            var $zoomedImg = $(this);
            $zoomedImg.addClass('b-product_image-zoom_image');
        }
    });
}

/**
 * initialize Events
 */
function initializeEvents() {
    var viewMode = layout.getMode();
    $(window).on('resize', function () {
        $(document).trigger('window.resize');
        var layoutView = layout.getMode();
        if (viewMode !== layoutView) {
            viewMode = layoutView;
            $(document).trigger('window.modechanged', { mode: viewMode });
        }
    });

    loadZoom();
    initMobileZoomEvent();

    $('body').on('product:afterAttributeSelect', function () {
        loadZoom();
        initMobileZoomEvent();

        $('.carousel-container .product-carousel').on('afterChange', function () {
            loadZoom();
            initMobileZoomEvent();
        });
    });

    $('.carousel-container .product-carousel').on('afterChange', function () {
        loadZoom();
        initMobileZoomEvent();
    });

    $(window).on('window.modechanged', function () {
        $('.product-wrapper').find('.carousel-item.slick-active .js-main-image').trigger('zoom.destroy').off('touchmove.zoom');
        $('.product-carousel').slick('slickSetOption', 'swipe', true, false);

        $('.b-product_image-zoom_image').remove();
        loadZoom();
        initMobileZoomEvent();
    });
}

/**
 * @description mobile zoom handler
 */
function initMobileZoomEvent() {
    if (!layout.isDesktop()) {
        $('.product-wrapper .carousel-item.slick-active .js-main-image').off('click').doubletap(function (event) {
            loadMobileZoom(event);
        });
    }
}

module.exports = function () {
    // If zoom is enabled based on Site Preference enableZoom
    if ($('.zoom-enabled').length > 0) {
        initializeEvents();
    }
};
